var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.2,
    width: 19.6,
    height: 19.6,
    fill: "#F2F3F5",
    stroke: "#7A8799",
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 5L7.50001 14.1667L3.33334 10",
    stroke: "#0D2A56",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.2,
    width: 19.6,
    height: 19.6,
    stroke: "#7A8799",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxChecked);
export default __webpack_public_path__ + "static/media/box-checked.8123d7da0617f6dff6acf0d9bdd6323d.svg";
export { ForwardRef as ReactComponent };